export const MUSIC_LIBRARY = {
    artists: [
        {
            id: 'ppy',
            name: 'PPY',
            albums: [
                {
                    id: 'devotion',
                    name: 'Devotion',
                    year: 2026,
                    coverImage: 'images/albums/album_devotion.png',
                    coverImagePublic: 'album_devotion',
                    songs: [
                        {
                            id: 'Want_Me',
                            title: 'Want Me',
                            path: 'music/Want_Me.mp3',
                            pathPublic: 'Want_Me',
                            tags: ['K-pop', 'Pop', 'Hip-Hop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 202,
                        },
                        {
                            id: 'Natural',
                            title: 'Natural',
                            path: 'music/Natural.mp3',
                            pathPublic: 'Natural',
                            tags: ['K-pop', 'Pop', 'Hip-Hop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 136,
                        },
                    ],
                },
            ],
        },
        {
            id: 'poptimus-prime',
            name: 'Poptimus Prime',
            albums: [
                {
                    id: 'beta-together',
                    name: 'Beta Together',
                    year: 2025,
                    coverImage: 'images/albums/album_beta_together.png',
                    coverImagePublic: 'album_beta_together',
                    songs: [
                        {
                            id: 'AFK',
                            title: 'AFK',
                            path: 'music/AFK.mp3',
                            pathPublic: 'AFK',
                            tags: [
                                'Chillhop',
                                'Lo-fi',
                                'Mellow',
                                'Lounge',
                                'Jazzy',
                                'Beatstrumental',
                            ],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 110,
                        },
                        {
                            id: 'Merry_Glitchmas',
                            title: 'Merry Glitchmas',
                            path: 'music/Merry_Glitchmas.mp3',
                            pathPublic: 'Merry_Glitchmas',
                            tags: ['Indietronica', 'Glitch', 'Electronic'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 142,
                        },
                        {
                            id: 'Background_Process',
                            title: 'Background Process',
                            path: 'music/Background_Process.mp3',
                            pathPublic: 'Background_Process',
                            tags: [
                                'Chillhop',
                                'Lo-fi',
                                'Mellow',
                                'Lounge',
                                'Jazzy',
                                'Beatstrumental',
                            ],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 111,
                        },
                        {
                            id: 'Feline_Fine',
                            title: 'Feline Fine',
                            path: 'music/Feline_Fine.mp3',
                            pathPublic: 'Feline_Fine',
                            tags: ['Chillhop', 'Lo-fi', 'Mellow', 'Lounge', 'Jazzy'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 96,
                        },
                        {
                            id: 'Solid_State_of_Mind',
                            title: 'Solid State of Mind',
                            path: 'music/Solid_State_of_Mind.mp3',
                            pathPublic: 'Solid_State_of_Mind',
                            tags: [
                                'Chillhop',
                                'Lo-fi',
                                'Mellow',
                                'Lounge',
                                'Jazzy',
                                'Beatstrumental',
                            ],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 157,
                        },
                        {
                            id: 'Scene_Audit',
                            title: 'Scene Audit',
                            path: 'music/Scene_Audit.mp3',
                            pathPublic: 'Scene_Audit',
                            tags: ['Chillhop', 'Indietronica', 'Lo-fi', 'Glitch'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 163,
                        },
                        {
                            id: 'Sunday_Stroll',
                            title: 'Sunday Stroll',
                            path: 'music/Sunday_Stroll.mp3',
                            pathPublic: 'Sunday_Stroll',
                            tags: [
                                'Chillhop',
                                'Lo-fi',
                                'Mellow',
                                'Lounge',
                                'Jazzy',
                                'Beatstrumental',
                            ],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 162,
                        },
                    ],
                },
            ],
        },
        {
            id: 'paper-pop-riot',
            name: 'Paper Pop Riot',
            albums: [
                {
                    id: 'about-to-blow',
                    name: 'About To Blow',
                    year: 2025,
                    coverImage: 'images/albums/album_about_to_blow2.png',
                    coverImagePublic: 'album_about_to_blow2',
                    songs: [
                        {
                            id: 'Award_Season',
                            title: 'Award Season',
                            path: 'music/Award_Season.mp3',
                            pathPublic: 'Award_Season',
                            tags: ['Pop', 'Rock', 'Electronic'],
                            language: ['en'],
                            lyrics: true,
                            game: '68016cb23f0914bff706b7ca',
                            duration: 162,
                        },
                        {
                            id: 'Click_Click_Snap',
                            title: 'Click Click Snap',
                            path: 'music/Click_Click_Snap.mp3',
                            pathPublic: 'Click_Click_Snap',
                            tags: ['Pop', 'Rock', 'Electronic'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 140,
                        },
                        {
                            id: 'Meme_Dream',
                            title: 'Meme Dream',
                            path: 'music/Meme_Dream.mp3',
                            pathPublic: 'Meme_Dream',
                            tags: ['Pop', 'Rock', 'Electronic'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 130,
                        },
                        {
                            id: 'Vital_Signs',
                            title: 'Vital Signs',
                            path: 'music/Vital_Signs.mp3',
                            pathPublic: 'Vital_Signs',
                            tags: ['Pop', 'Punk', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6921e33b0eef394c89845fb8',
                            duration: 175,
                        },
                        {
                            id: 'Alice',
                            title: 'Alice',
                            path: 'music/Alice.mp3',
                            pathPublic: 'Alice',
                            tags: ['Pop', 'Punk', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '69ac5a4510c9adc947dc1981',
                            duration: 210,
                        },
                        {
                            id: 'Red_Tape',
                            title: 'Red Tape',
                            path: 'music/Red_Tape.mp3',
                            pathPublic: 'Red_Tape',
                            tags: ['Pop', 'Punk', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 232,
                        },
                        {
                            id: 'Under_Oath',
                            title: 'Under Oath',
                            path: 'music/Under_Oath.mp3',
                            pathPublic: 'Under_Oath',
                            tags: ['Pop', 'Punk', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 186,
                        },
                    ],
                },
            ],
        },
        {
            id: 'grace-poppins',
            name: 'Grace Poppins',
            albums: [
                {
                    id: 'saddles-servers',
                    name: 'Saddles & Servers',
                    year: 2025,
                    coverImage: 'images/albums/album_saddles_servers.png',
                    coverImagePublic: 'album_saddles_servers',
                    songs: [
                        {
                            id: 'Big_Hats_Bigger_Egos',
                            title: 'Big Hats, Bigger Egos',
                            path: 'music/Big_Hats_Bigger_Egos.mp3',
                            pathPublic: 'Big_Hats_Bigger_Egos',
                            tags: ['Country', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '68016cb23f0914bff706b7ca',
                            duration: 133,
                        },
                        {
                            id: 'Eyes_Wide_Open_Oh_Prairie_Dog',
                            title: 'Eyes Wide Open (Oh Prairie Dog)',
                            path: 'music/Eyes_Wide_Open_Oh_Prairie_Dog.mp3',
                            pathPublic: 'Eyes_Wide_Open_Oh_Prairie_Dog',
                            tags: ['Country', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 147,
                        },
                        {
                            id: 'Extra_Extra',
                            title: 'Extra Extra',
                            path: 'music/Extra_Extra.mp3',
                            pathPublic: 'Extra_Extra',
                            tags: ['Country', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '68eb1f40d63530c3bfd356e6',
                            duration: 233,
                        },
                        {
                            id: 'Spell_It_Out',
                            title: 'Spell It Out',
                            path: 'music/Spell_It_Out.mp3',
                            pathPublic: 'Spell_It_Out',
                            tags: ['Country', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '693bad642f3a8ff742190144',
                            duration: 194,
                        },
                        {
                            id: 'Bless_Your_Heart',
                            title: 'Bless Your Heart',
                            path: 'music/Bless_Your_Heart.mp3',
                            pathPublic: 'Bless_Your_Heart',
                            tags: ['Country', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '69ac5a4510c9adc947dc1981',
                            duration: 256,
                        },
                        {
                            id: 'Til_The_Cows_Come_Home',
                            title: 'Til The Cows Come Home',
                            path: 'music/Til_The_Cows_Come_Home.mp3',
                            pathPublic: 'Til_The_Cows_Come_Home',
                            tags: ['Country', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 248,
                        },
                        {
                            id: 'Aint_That_Suspicious',
                            title: "Ain't That Suspicious",
                            path: 'music/Aint_That_Suspicious.mp3',
                            pathPublic: 'Aint_That_Suspicious',
                            tags: ['Country', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 218,
                        },
                    ],
                },
            ],
        },
        {
            id: 'pop-zickle',
            name: 'Pop Zickle',
            albums: [
                {
                    id: 'hotspot',
                    name: 'Hotspot',
                    year: 2025,
                    coverImage: 'images/albums/album_hotspot.png',
                    coverImagePublic: 'album_hotspot',
                    songs: [
                        {
                            id: 'Connected',
                            title: 'Connected',
                            path: 'music/Connected.mp3',
                            pathPublic: 'Connected',
                            tags: ['Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 167,
                        },
                        {
                            id: 'Vote_for_Me',
                            title: 'Vote for Me',
                            path: 'music/Vote_for_Me.mp3',
                            pathPublic: 'Vote_for_Me',
                            tags: ['Pop', 'Soul', 'R&B', 'Ballad'],
                            language: ['en'],
                            lyrics: true,
                            game: '68016cb23f0914bff706b7ca',
                            duration: 189,
                        },
                        {
                            id: 'Stitches_Over_Scars',
                            title: 'Stitches Over Scars',
                            path: 'music/Stitches_Over_Scars.mp3',
                            pathPublic: 'Stitches_Over_Scars',
                            tags: ['Pop', 'Soul', 'R&B', 'Ballad'],
                            language: ['en'],
                            lyrics: true,
                            game: '6921e33b0eef394c89845fb8',
                            duration: 218,
                        },
                        {
                            id: 'Inspired',
                            title: 'Inspired',
                            path: 'music/Inspired.mp3',
                            pathPublic: 'Inspired',
                            tags: ['Pop', 'Soul', 'R&B', 'Ballad'],
                            language: ['en'],
                            lyrics: true,
                            game: '693bad642f3a8ff742190144',
                            duration: 220,
                        },
                        {
                            id: 'Greener_Pastures',
                            title: 'Greener Pastures',
                            path: 'music/Greener_Pastures.mp3',
                            pathPublic: 'Greener_Pastures',
                            tags: ['Pop', 'Soul', 'R&B', 'Ballad'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 178,
                        },
                        {
                            id: 'Stamped_Across_My_Heart',
                            title: 'Stamped Across My Heart',
                            path: 'music/Stamped_Across_My_Heart.mp3',
                            pathPublic: 'Stamped_Across_My_Heart',
                            tags: ['Pop', 'Soul', 'R&B', 'Ballad'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 227,
                        },
                        {
                            id: 'Framed',
                            title: 'Framed',
                            path: 'music/Framed.mp3',
                            pathPublic: 'Framed',
                            tags: ['Pop', 'Soul', 'R&B', 'Ballad'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 263,
                        },
                    ],
                },
            ],
        },
        {
            id: 'poppa-shot',
            name: 'Poppa Shot',
            albums: [
                {
                    id: 'lit-up-glitched-out',
                    name: 'Lit Up & Glitched Out',
                    year: 2025,
                    coverImage: 'images/albums/album_lit_up_glitched_out.png',
                    coverImagePublic: 'album_lit_up_glitched_out',
                    songs: [
                        {
                            id: 'Ego_Dreamin',
                            title: 'Ego Dreamin',
                            path: 'music/Ego_Dreamin.mp3',
                            pathPublic: 'Ego_Dreamin',
                            tags: ['Hip Hop', 'Rap', 'Boom Bap', 'Soul'],
                            language: ['en'],
                            lyrics: true,
                            game: '68016cb23f0914bff706b7ca',
                            duration: 130,
                        },
                        {
                            id: 'PBJ_Days',
                            title: 'PB&J Days',
                            path: 'music/PBJ_Days.mp3',
                            pathPublic: 'PBJ_Days',
                            tags: ['Hip Hop', 'Rap', 'Boom Bap', 'Soul'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 120,
                        },
                        {
                            id: 'Newsworthy',
                            title: 'Newsworthy',
                            path: 'music/Newsworthy.mp3',
                            pathPublic: 'Newsworthy',
                            tags: ['Hip Hop', 'Rap', 'Boom Bap', 'Soul'],
                            language: ['en'],
                            lyrics: true,
                            game: '68eb1f40d63530c3bfd356e6',
                            duration: 208,
                        },
                        {
                            id: 'No_As',
                            title: "No A's",
                            path: 'music/No_As.mp3',
                            pathPublic: 'No_As',
                            tags: ['Hip Hop', 'Rap', 'Boom Bap', 'Soul'],
                            language: ['en'],
                            lyrics: true,
                            game: '693bad642f3a8ff742190144',
                            duration: 152,
                        },
                        {
                            id: 'Old_Mac',
                            title: 'Old Mac',
                            path: 'music/Old_Mac.mp3',
                            pathPublic: 'Old_Mac',
                            tags: ['Hip Hop', 'Rap', 'Boom Bap', 'Soul'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 234,
                        },
                        {
                            id: 'The_Beast',
                            title: 'The Beast',
                            path: 'music/The_Beast.mp3',
                            pathPublic: 'The_Beast',
                            tags: ['Hip Hop', 'Rap', 'Boom Bap'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 180,
                        },
                    ],
                },
            ],
        },
        {
            id: 'popwood-hollows',
            name: 'Popwood Hollows',
            albums: [
                {
                    id: 'firewalls',
                    name: 'Firewalls',
                    year: 2025,
                    coverImage: 'images/albums/album_firewalls.png',
                    coverImagePublic: 'album_firewalls',
                    songs: [
                        {
                            id: 'Half_a_Thought_Half_a_Bite',
                            title: 'Half a Thought, Half a Bite',
                            path: 'music/Half_a_Thought_Half_a_Bite.mp3',
                            pathPublic: 'Half_a_Thought_Half_a_Bite',
                            tags: ['Folk', 'Acoustic'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 210,
                        },
                        {
                            id: 'World_Aflame_This_is_Fine',
                            title: 'World Aflame (This is Fine)',
                            path: 'music/World_Aflame_This_is_Fine.mp3',
                            pathPublic: 'World_Aflame_This_is_Fine',
                            tags: ['Folk', 'Acoustic', 'Duets'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 168,
                        },
                        {
                            id: 'You_Buried_the_Lede_Love',
                            title: 'You Buried the Lede, Love',
                            path: 'music/You_Buried_the_Lede_Love.mp3',
                            pathPublic: 'You_Buried_the_Lede_Love',
                            tags: ['Folk', 'Acoustic'],
                            language: ['en'],
                            lyrics: true,
                            game: '68eb1f40d63530c3bfd356e6',
                            duration: 195,
                        },
                        {
                            id: 'Hurt_Me_Heal_Me',
                            title: 'Hurt Me, Heal Me',
                            path: 'music/Hurt_Me_Heal_Me.mp3',
                            pathPublic: 'Hurt_Me_Heal_Me',
                            tags: ['Folk', 'Acoustic', 'Duets'],
                            language: ['en'],
                            lyrics: true,
                            game: '6921e33b0eef394c89845fb8',
                            duration: 284,
                        },
                        {
                            id: 'Burnt_Edges',
                            title: 'Burnt Edges',
                            path: 'music/Burnt_Edges.mp3',
                            pathPublic: 'Burnt_Edges',
                            tags: ['Folk', 'Acoustic', 'Duets'],
                            language: ['en'],
                            lyrics: true,
                            game: '6944abab5d2f2d3fde971460',
                            duration: 224,
                        },
                        {
                            id: 'What_We_Found',
                            title: 'What We Found',
                            path: 'music/What_We_Found.mp3',
                            pathPublic: 'What_We_Found',
                            tags: ['Folk', 'Acoustic', 'Duets'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 294,
                        },
                    ],
                },
            ],
        },
        {
            id: 'popstorm',
            name: 'PØPSTØRM',
            albums: [
                {
                    id: 'nightly-build',
                    name: 'Nightly Build',
                    year: 2025,
                    coverImage: 'images/albums/album_nightly_build.png',
                    coverImagePublic: 'album_nightly_build',
                    songs: [
                        {
                            id: 'Neon_Bloom',
                            title: 'Neon Bloom',
                            path: 'music/Neon_Bloom.mp3',
                            pathPublic: 'Neon_Bloom',
                            tags: ['Electronic', 'Future Bass', 'Synth Pop'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 240,
                        },
                        {
                            id: 'Ready_Set_Glow',
                            title: 'Ready Set Glow',
                            path: 'music/Ready_Set_Glow.mp3',
                            pathPublic: 'Ready_Set_Glow',
                            tags: ['Electronic', 'Future Bass', 'Synth Pop'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 168,
                        },
                        {
                            id: 'Reboot',
                            title: 'Reboot',
                            path: 'music/Reboot.mp3',
                            pathPublic: 'Reboot',
                            tags: ['Electronic', 'Future Bass', 'Synth Pop'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 240,
                        },
                        {
                            id: 'Deep_Learning',
                            title: 'Deep Learning',
                            path: 'music/Deep_Learning.mp3',
                            pathPublic: 'Deep_Learning',
                            tags: ['Electronic', 'Trance', 'EDM'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 170,
                        },
                        {
                            id: 'Transformer',
                            title: 'Transformer',
                            path: 'music/Transformer.mp3',
                            pathPublic: 'Transformer',
                            tags: ['Electronic', 'Trance', 'EDM'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 171,
                        },
                    ],
                },
            ],
        },
        {
            id: 'troppy',
            name: 'Troppy',
            albums: [
                {
                    id: 'float',
                    name: 'Float',
                    year: 2025,
                    coverImage: 'images/albums/album_float.png',
                    coverImagePublic: 'album_float',
                    songs: [
                        {
                            id: 'Pawsitive',
                            title: 'Pawsitive',
                            path: 'music/Pawsitive.mp3',
                            pathPublic: 'Pawsitive',
                            tags: ['Tropical House', 'Pop'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 100,
                        },
                        {
                            id: 'Still_Pawsitive',
                            title: 'Still Pawsitive (feat. Pop Zickle)',
                            path: 'music/Still_Pawsitive.mp3',
                            pathPublic: 'Still_Pawsitive',
                            tags: ['Tropical House', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: 'none',
                            duration: 116,
                        },
                        {
                            id: 'Palm_Tree_Pilot',
                            title: 'Palm Tree Pilot',
                            path: 'music/Palm_Tree_Pilot.mp3',
                            pathPublic: 'Palm_Tree_Pilot',
                            tags: ['Tropical House', 'Pop'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 180,
                        },
                        {
                            id: 'Cloud_Cabana',
                            title: 'Cloud Cabana',
                            path: 'music/Cloud_Cabana.mp3',
                            pathPublic: 'Cloud_Cabana',
                            tags: ['Tropical House', 'Pop'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 180,
                        },
                        {
                            id: 'Just_My_Type',
                            title: 'Just My Type (feat. Pōpulele)',
                            path: 'music/Just_My_Type.mp3',
                            pathPublic: 'Just_My_Type',
                            tags: ['Chill', 'Acoustic', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: 'none',
                            duration: 131,
                        },
                    ],
                },
            ],
        },
        {
            id: 'midnight-poppers',
            name: 'The Midnight Poppers',
            albums: [
                {
                    id: 'debug-destroy',
                    name: 'Debug & Destroy',
                    year: 2025,
                    coverImage: 'images/albums/album_debug_destroy.png',
                    coverImagePublic: 'album_debug_destroy',
                    songs: [
                        {
                            id: 'Pickles_and_Mustard',
                            title: 'Pickles and Mustard',
                            path: 'music/Pickles_and_Mustard.mp3',
                            pathPublic: 'Pickles_and_Mustard',
                            tags: ['Rock', 'Punk'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 125,
                        },
                        {
                            id: 'Your_New_King',
                            title: 'Your New King',
                            path: 'music/Your_New_King.mp3',
                            pathPublic: 'Your_New_King',
                            tags: ['Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '68016cb23f0914bff706b7ca',
                            duration: 169,
                        },
                        {
                            id: 'Stop_The_Presses',
                            title: 'Stop The Presses',
                            path: 'music/Stop_The_Presses.mp3',
                            pathPublic: 'Stop_The_Presses',
                            tags: ['Rock', 'Punk'],
                            language: ['en'],
                            lyrics: true,
                            game: '68eb1f40d63530c3bfd356e6',
                            duration: 180,
                        },
                        {
                            id: 'Scrub_Up',
                            title: 'Scrub Up!',
                            path: 'music/Scrub_Up.mp3',
                            pathPublic: 'Scrub_Up',
                            tags: ['Rock', 'Punk'],
                            language: ['en'],
                            lyrics: true,
                            game: '6921e33b0eef394c89845fb8',
                            duration: 104,
                        },
                        {
                            id: 'Boil_Over',
                            title: 'Boil Over',
                            path: 'music/Boil_Over.mp3',
                            pathPublic: 'Boil_Over',
                            tags: ['Rock', 'Punk'],
                            language: ['en'],
                            lyrics: true,
                            game: '6944abab5d2f2d3fde971460',
                            duration: 145,
                        },
                        {
                            id: 'Population_Control',
                            title: 'Population Control',
                            path: 'music/Population_Control.mp3',
                            pathPublic: 'Population_Control',
                            tags: ['Rock', 'Punk'],
                            language: ['en'],
                            lyrics: true,
                            game: '69ac5a4510c9adc947dc1981',
                            duration: 156,
                        },
                        {
                            id: 'Your_Thing',
                            title: 'Your Thing',
                            path: 'music/Your_Thing.mp3',
                            pathPublic: 'Your_Thing',
                            tags: ['Rock', 'Punk'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 148,
                        },
                    ],
                },
            ],
        },
        {
            id: 'pop-yuler-404s',
            name: 'Pop Yuler & The 404s',
            albums: [
                {
                    id: 'escape-my-heart',
                    name: 'Escape My Heart',
                    year: 2025,
                    coverImage: 'images/albums/album_escape_my_heart.png',
                    coverImagePublic: 'album_escape_my_heart',
                    songs: [
                        {
                            id: 'Pixelscape',
                            title: 'Pixelscape',
                            path: 'music/Pixelscape.mp3',
                            pathPublic: 'Pixelscape',
                            tags: ['Indie Pop', 'Alt Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 136,
                        },
                        {
                            id: 'Feel_It_In_Your_Soul',
                            title: 'Feel It In Your Soul',
                            path: 'music/Feel_It_In_Your_Soul.mp3',
                            pathPublic: 'Feel_It_In_Your_Soul',
                            tags: ['Indie Pop', 'Alt Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 184,
                        },
                        {
                            id: 'Read_All_Over',
                            title: 'Read All Over',
                            path: 'music/Read_All_Over.mp3',
                            pathPublic: 'Read_All_Over',
                            tags: ['Indie Pop', 'Alt Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '68eb1f40d63530c3bfd356e6',
                            duration: 191,
                        },
                        {
                            id: 'Take_Five',
                            title: 'Take Five',
                            path: 'music/Take_Five.mp3',
                            pathPublic: 'Take_Five',
                            tags: ['Indie Pop', 'Alt Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '693bad642f3a8ff742190144',
                            duration: 190,
                        },
                        {
                            id: 'Reap_What_You_Sow',
                            title: 'Reap What You Sow',
                            path: 'music/Reap_What_You_Sow.mp3',
                            pathPublic: 'Reap_What_You_Sow',
                            tags: ['Indie Pop', 'Alt Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 193,
                        },
                        {
                            id: 'Its_Gonna_Be',
                            title: "It's Gonna Be",
                            path: 'music/Its_Gonna_Be.mp3',
                            pathPublic: 'Its_Gonna_Be',
                            tags: ['Indie Pop', 'Alt Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 263,
                        },
                        {
                            id: 'Caught_Me',
                            title: 'Caught Me',
                            path: 'music/Caught_Me.mp3',
                            pathPublic: 'Caught_Me',
                            tags: ['Indie Pop', 'Pop', 'Alt Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 201,
                        },
                    ],
                },
            ],
        },
        {
            id: 'irie-pop-collective',
            name: 'Irie Pop Collective',
            albums: [
                {
                    id: 'high-ping-vibes',
                    name: 'High Ping Vibes',
                    year: 2025,
                    coverImage: 'images/albums/album_high_ping_vibes.png',
                    coverImagePublic: 'album_high_ping_vibes',
                    songs: [
                        {
                            id: 'Turn_That_Frown_Around',
                            title: 'Turn That Frown Around',
                            path: 'music/Turn_That_Frown_Around.mp3',
                            pathPublic: 'Turn_That_Frown_Around',
                            tags: ['Reggae Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 151,
                        },
                        {
                            id: 'Sandwich_Psychic',
                            title: 'Sandwich Psychic',
                            path: 'music/Sandwich_Psychic.mp3',
                            pathPublic: 'Sandwich_Psychic',
                            tags: ['Reggae Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 135,
                        },
                        {
                            id: 'No_Deadlines',
                            title: 'No Deadlines',
                            path: 'music/No_Deadlines.mp3',
                            pathPublic: 'No_Deadlines',
                            tags: ['Reggae Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '68eb1f40d63530c3bfd356e6',
                            duration: 197,
                        },
                        {
                            id: 'Down_to_Hang',
                            title: 'Down to Hang',
                            path: 'music/Down_to_Hang.mp3',
                            pathPublic: 'Down_to_Hang',
                            tags: ['Reggae Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '693bad642f3a8ff742190144',
                            duration: 212,
                        },
                        {
                            id: 'Like_Rabbits',
                            title: 'Like Rabbits',
                            path: 'music/Like_Rabbits.mp3',
                            pathPublic: 'Like_Rabbits',
                            tags: ['Reggae Rock', 'Ska', 'Dub'],
                            language: ['en'],
                            lyrics: true,
                            game: '69ac5a4510c9adc947dc1981',
                            duration: 203,
                        },
                        {
                            id: 'Slow_Roll',
                            title: 'Slow Roll',
                            path: 'music/Slow_Roll.mp3',
                            pathPublic: 'Slow_Roll',
                            tags: ['Reggae Rock', 'Ska', 'Dub'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 233,
                        },
                        {
                            id: 'Wasnt_Me_Sweet_Treats',
                            title: "Wasn't Me (Sweet Treats)",
                            path: 'music/Wasnt_Me_Sweet_Treats.mp3',
                            pathPublic: 'Wasnt_Me_Sweet_Treats',
                            tags: ['Reggae Rock', 'Reggae', 'Dub'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 248,
                        },
                    ],
                },
            ],
        },
        {
            id: 'populele',
            name: 'Pōpulele',
            albums: [
                {
                    id: 'wavelengths-waterfalls',
                    name: 'Wavelengths & Waterfalls',
                    year: 2025,
                    coverImage: 'images/albums/album_wavelengths_waterfalls.png',
                    coverImagePublic: 'album_wavelengths_waterfalls',
                    songs: [
                        {
                            id: 'Threes_a_Crowd',
                            title: `Three's a Crowd`,
                            path: 'music/Threes_a_Crowd.mp3',
                            pathPublic: 'Threes_a_Crowd',
                            tags: ['Hawaiian', 'Folk', 'Acoustic'],
                            language: ['en'],
                            lyrics: true,
                            game: '6944abab5d2f2d3fde971460',
                            duration: 190,
                        },
                        {
                            id: 'Mahalo',
                            title: 'Mahalo',
                            path: 'music/Mahalo.mp3',
                            pathPublic: 'Mahalo',
                            tags: ['Hawaiian', 'Folk', 'Acoustic'],
                            language: ['en'],
                            lyrics: true,
                            game: '68016cb23f0914bff706b7ca',
                            duration: 206,
                        },
                        {
                            id: 'What_Does_It_Mean',
                            title: 'What Does It Mean?',
                            path: 'music/What_Does_It_Mean.mp3',
                            pathPublic: 'What_Does_It_Mean',
                            tags: ['Hawaiian', 'Folk', 'Acoustic'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 139,
                        },
                        {
                            id: 'Golden_Horizons',
                            title: 'Golden Horizons',
                            path: 'music/Golden_Horizons.mp3',
                            pathPublic: 'Golden_Horizons',
                            tags: ['Acoustic'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 186,
                        },
                        {
                            id: 'Ocean_Whisper',
                            title: 'Ocean Whisper',
                            path: 'music/Ocean_Whisper.mp3',
                            pathPublic: 'Ocean_Whisper',
                            tags: ['Acoustic'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 134,
                        },
                        {
                            id: 'Luau',
                            title: 'Luau',
                            path: 'music/Luau.mp3',
                            pathPublic: 'Luau',
                            tags: ['Hawaiian', 'Folk', 'Acoustic'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 224,
                        },
                        {
                            id: 'Good_Enough_for_Me',
                            title: 'Good Enough for Me',
                            path: 'music/Good_Enough_for_Me.mp3',
                            pathPublic: 'Good_Enough_for_Me',
                            tags: ['Hawaiian', 'Folk', 'Acoustic'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 238,
                        },
                        {
                            id: 'Footprints',
                            title: 'Footprints',
                            path: 'music/Footprints.mp3',
                            pathPublic: 'Footprints',
                            tags: ['Hawaiian', 'Folk', 'Acoustic'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 230,
                        },
                    ],
                },
            ],
        },
        {
            id: 'pop-goes-fiddle',
            name: 'Pop Goes The Fiddle',
            albums: [
                {
                    id: 'string-theory',
                    name: 'String Theory',
                    year: 2025,
                    coverImage: 'images/albums/album_string_theory.png',
                    coverImagePublic: 'album_string_theory',
                    songs: [
                        {
                            id: 'Frankly_Debatable',
                            title: 'Frankly Debatable',
                            path: 'music/Frankly_Debatable.mp3',
                            pathPublic: 'Frankly_Debatable',
                            tags: ['Country', 'Bluegrass'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 160,
                        },
                        {
                            id: 'Rigged',
                            title: 'Rigged',
                            path: 'music/Rigged.mp3',
                            pathPublic: 'Rigged',
                            tags: ['Country', 'Bluegrass'],
                            language: ['en'],
                            lyrics: true,
                            game: '68016cb23f0914bff706b7ca',
                            duration: 190,
                        },
                        {
                            id: 'The_Healer',
                            title: 'The Healer',
                            path: 'music/The_Healer.mp3',
                            pathPublic: 'The_Healer',
                            tags: ['Country', 'Bluegrass', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6921e33b0eef394c89845fb8',
                            duration: 177,
                        },
                        {
                            id: 'Revenge',
                            title: 'Revenge',
                            path: 'music/Revenge.mp3',
                            pathPublic: 'Revenge',
                            tags: ['Country', 'Bluegrass', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6944abab5d2f2d3fde971460',
                            duration: 187,
                        },
                        {
                            id: 'Hop',
                            title: 'Hop',
                            path: 'music/Hop.mp3',
                            pathPublic: 'Hop',
                            tags: ['Country', 'Bluegrass'],
                            language: ['en'],
                            lyrics: false,
                            game: '69ac5a4510c9adc947dc1981',
                            duration: 142,
                        },
                        {
                            id: 'Hay_Fever',
                            title: 'Hay Fever',
                            path: 'music/Hay_Fever.mp3',
                            pathPublic: 'Hay_Fever',
                            tags: ['Country', 'Bluegrass'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 239,
                        },
                        {
                            id: 'Creature_of_Habit',
                            title: 'Creature of Habit',
                            path: 'music/Creature_of_Habit.mp3',
                            pathPublic: 'Creature_of_Habit',
                            tags: ['Country', 'Bluegrass'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 172,
                        },
                    ],
                },
            ],
        },
        {
            id: 'velocipopter',
            name: 'Velocipopter',
            albums: [
                {
                    id: 'cache-money',
                    name: 'Cache Money',
                    year: 2025,
                    coverImage: 'images/albums/album_cache_money.png',
                    coverImagePublic: 'album_cache_money',
                    songs: [
                        {
                            id: 'King_of_Clout',
                            title: 'King of Clout',
                            path: 'music/King_of_Clout.mp3',
                            pathPublic: 'King_of_Clout',
                            tags: ['Rap', 'Hip Hop'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 100,
                        },
                        {
                            id: 'Stackin_Chedda',
                            title: 'Stackin Chedda',
                            path: 'music/Stackin_Chedda.mp3',
                            pathPublic: 'Stackin_Chedda',
                            tags: ['Rap', 'Hip Hop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 121,
                        },
                        {
                            id: 'GOAT',
                            title: 'GOAT',
                            path: 'music/GOAT.mp3',
                            pathPublic: 'GOAT',
                            tags: ['Rap', 'Hip Hop'],
                            language: ['en'],
                            lyrics: true,
                            game: '68eb1f40d63530c3bfd356e6',
                            duration: 172,
                        },
                        {
                            id: 'Midnight_Rounds',
                            title: 'Midnight Rounds',
                            path: 'music/Midnight_Rounds.mp3',
                            pathPublic: 'Midnight_Rounds',
                            tags: ['Rap', 'Hip Hop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6921e33b0eef394c89845fb8',
                            duration: 123,
                        },
                        {
                            id: 'Still_Hungry',
                            title: 'Still Hungry',
                            path: 'music/Still_Hungry.mp3',
                            pathPublic: 'Still_Hungry',
                            tags: ['Rap', 'Hip Hop', 'Trap'],
                            language: ['en'],
                            lyrics: true,
                            game: '6944abab5d2f2d3fde971460',
                            duration: 120,
                        },
                        {
                            id: 'Okay_Nah',
                            title: 'Okay, Nah',
                            path: 'music/Okay_Nah.mp3',
                            pathPublic: 'Okay_Nah',
                            tags: ['Rap', 'Hip Hop', 'Hyphy'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 134,
                        },
                    ],
                },
            ],
        },
        {
            id: 'papacito',
            name: 'Papacito',
            albums: [
                {
                    id: 'sin-senal',
                    name: 'Sin Señal',
                    year: 2025,
                    coverImage: 'images/albums/album_sin_senal.png',
                    coverImagePublic: 'album_sin_senal',
                    songs: [
                        {
                            id: 'Torta_Grande',
                            title: 'Torta Grande',
                            path: 'music/Torta_Grande.mp3',
                            pathPublic: 'Torta_Grande',
                            tags: ['Reggaeton', 'Pop'],
                            language: ['en', 'es'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 124,
                        },
                        {
                            id: 'But_When_I_Do',
                            title: 'But When I Do',
                            path: 'music/But_When_I_Do.mp3',
                            pathPublic: 'But_When_I_Do',
                            tags: ['Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 152,
                        },
                        {
                            id: 'Soy_Mejor',
                            title: 'Soy Mejor',
                            path: 'music/Soy_Mejor.mp3',
                            pathPublic: 'Soy_Mejor',
                            tags: ['Reggaeton', 'Pop'],
                            language: ['en', 'es'],
                            lyrics: true,
                            game: '68016cb23f0914bff706b7ca',
                            duration: 112,
                        },
                        {
                            id: 'Ahorcado',
                            title: 'Ahorcado',
                            path: 'music/Ahorcado.mp3',
                            pathPublic: 'Ahorcado',
                            tags: ['Reggaeton', 'Pop'],
                            language: ['es'],
                            lyrics: true,
                            game: '693bad642f3a8ff742190144',
                            duration: 188,
                        },
                        {
                            id: 'Debi_Tirar_Mas_Lechuga',
                            title: 'Debí Tirar Más Lechuga',
                            path: 'music/Debi_Tirar_Mas_Lechuga.mp3',
                            pathPublic: 'Debi_Tirar_Mas_Lechuga',
                            tags: ['Reggaeton', 'Pop'],
                            language: ['en', 'es'],
                            lyrics: true,
                            game: '69ac5a4510c9adc947dc1981',
                            duration: 187,
                        },
                        {
                            id: 'Ultimo_Aviso',
                            title: 'Último Aviso',
                            path: 'music/Ultimo_Aviso.mp3',
                            pathPublic: 'Ultimo_Aviso',
                            tags: ['Reggaeton', 'Pop'],
                            language: ['en', 'es'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 179,
                        },
                        {
                            id: 'Want_It_Need_It',
                            title: 'Want It, Need It',
                            path: 'music/Want_It_Need_It.mp3',
                            pathPublic: 'Want_It_Need_It',
                            tags: ['Pop', 'Dance', 'Latin'],
                            language: ['en', 'es'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 214,
                        },
                    ],
                },
            ],
        },
        {
            id: 'poparazzi',
            name: 'Poparazzi',
            albums: [
                {
                    id: 'bursting-at-the-seams',
                    name: 'Bursting at the Seams',
                    year: 2025,
                    coverImage: 'images/albums/album_bursting_at_the_seams.png',
                    coverImagePublic: 'album_bursting_at_the_seams',
                    songs: [
                        {
                            id: 'Bedside_Manner',
                            title: 'Bedside Manner',
                            path: 'music/Bedside_Manner.mp3',
                            pathPublic: 'Bedside_Manner',
                            tags: ['Hip Hop', 'Pop', 'Funk'],
                            language: ['en'],
                            lyrics: true,
                            game: '6921e33b0eef394c89845fb8',
                            duration: 125,
                        },
                        {
                            id: 'Whats_Happenin',
                            title: "What's Happenin'",
                            path: 'music/Whats_Happenin.mp3',
                            pathPublic: 'Whats_Happenin',
                            tags: ['Hip Hop', 'Pop', 'Funk'],
                            language: ['en'],
                            lyrics: true,
                            game: '68eb1f40d63530c3bfd356e6',
                            duration: 131,
                        },
                        {
                            id: 'Stacked',
                            title: 'Stacked',
                            path: 'music/Stacked.mp3',
                            pathPublic: 'Stacked',
                            tags: ['Hip Hop', 'Pop', 'Funk'],
                            language: ['en'],
                            lyrics: true,
                            game: '693bad642f3a8ff742190144',
                            duration: 158,
                        },
                        {
                            id: 'Saucy',
                            title: 'Saucy',
                            path: 'music/Saucy.mp3',
                            pathPublic: 'Saucy',
                            tags: ['Hip Hop', 'Pop', 'Funk'],
                            language: ['en'],
                            lyrics: true,
                            game: '6944abab5d2f2d3fde971460',
                            duration: 164,
                        },
                        {
                            id: 'Crop_Tops',
                            title: 'Crop Tops',
                            path: 'music/Crop_Tops.mp3',
                            pathPublic: 'Crop_Tops',
                            tags: ['Hip Hop', 'Pop', 'Funk'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 156,
                        },
                        {
                            id: 'Guilty_as_Charged',
                            title: 'Guilty as Charged',
                            path: 'music/Guilty_as_Charged.mp3',
                            pathPublic: 'Guilty_as_Charged',
                            tags: ['Hip Hop', 'Pop', 'Funk', 'Soul'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 215,
                        },
                        {
                            id: 'Go_Wild',
                            title: 'Go Wild',
                            path: 'music/Go_Wild.mp3',
                            pathPublic: 'Go_Wild',
                            tags: ['Hip Hop', 'Pop', 'Funk'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 151,
                        },
                    ],
                },
            ],
        },
        {
            id: 'pocket-popcorn',
            name: 'Pocket Popcorn',
            albums: [
                {
                    id: 'funkernel',
                    name: 'Funkernel',
                    year: 2025,
                    coverImage: 'images/albums/album_funkernel.png',
                    coverImagePublic: 'album_funkernel',
                    songs: [
                        {
                            id: 'Kettle_Cookin',
                            title: "Kettle Cookin'",
                            path: 'music/Kettle_Cookin.mp3',
                            pathPublic: 'Kettle_Cookin',
                            tags: ['Funk'],
                            language: ['en'],
                            lyrics: true,
                            game: 'none',
                            duration: 137,
                        },
                        {
                            id: 'Hot_Butter_Handshake',
                            title: 'Hot Butter Handshake',
                            path: 'music/Hot_Butter_Handshake.mp3',
                            pathPublic: 'Hot_Butter_Handshake',
                            tags: ['Funk'],
                            language: ['en'],
                            lyrics: true,
                            game: 'none',
                            duration: 110,
                        },
                        {
                            id: 'Socket_To_Me',
                            title: 'Socket To Me',
                            path: 'music/Socket_To_Me.mp3',
                            pathPublic: 'Socket_To_Me',
                            tags: ['Funk'],
                            language: ['en'],
                            lyrics: true,
                            game: 'none',
                            duration: 140,
                        },
                        {
                            id: 'Prescription_For_Funk',
                            title: 'Prescription For Funk',
                            path: 'music/Prescription_For_Funk.mp3',
                            pathPublic: 'Prescription_For_Funk',
                            tags: ['Funk', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6921e33b0eef394c89845fb8',
                            duration: 200,
                        },
                        {
                            id: 'The_Recipe',
                            title: 'The Recipe',
                            path: 'music/The_Recipe.mp3',
                            pathPublic: 'The_Recipe',
                            tags: ['Funk', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6944abab5d2f2d3fde971460',
                            duration: 192,
                        },
                        {
                            id: 'Bet_The_Farm',
                            title: 'Bet The Farm',
                            path: 'music/Bet_The_Farm.mp3',
                            pathPublic: 'Bet_The_Farm',
                            tags: ['Funk', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 193,
                        },
                        {
                            id: 'Dont_Deny_It',
                            title: "Don't Deny It",
                            path: 'music/Dont_Deny_It.mp3',
                            pathPublic: 'Dont_Deny_It',
                            tags: ['Funk', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 191,
                        },
                        {
                            id: 'Line_Up',
                            title: 'Line Up',
                            path: 'music/Line_Up.mp3',
                            pathPublic: 'Line_Up',
                            tags: ['Funk', 'Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 184,
                        },
                    ],
                },
            ],
        },
        {
            id: 'aster-van-popeling',
            name: 'Aster van Popeling',
            albums: [
                {
                    id: 'soft-launch',
                    name: 'Soft Launch',
                    year: 2025,
                    coverImage: 'images/albums/album_soft_launch.png',
                    coverImagePublic: 'album_soft_launch',
                    songs: [
                        {
                            id: 'Smudged_Ink',
                            title: 'Smudged Ink',
                            path: 'music/Smudged_Ink.mp3',
                            pathPublic: 'Smudged_Ink',
                            tags: ['R&B', 'Neo-Soul', 'Jazz Fusion'],
                            language: ['en'],
                            lyrics: true,
                            game: '68eb1f40d63530c3bfd356e6',
                            duration: 156,
                        },
                        {
                            id: 'I_Know_What_Youre_Thinking',
                            title: "I Know What You're Thinking",
                            path: 'music/I_Know_What_Youre_Thinking.mp3',
                            pathPublic: 'I_Know_What_Youre_Thinking',
                            tags: ['R&B', 'Neo-Soul', 'Jazz Fusion'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 195,
                        },
                        {
                            id: 'In_Good_Hands',
                            title: 'In Good Hands',
                            path: 'music/In_Good_Hands.mp3',
                            pathPublic: 'In_Good_Hands',
                            tags: ['R&B', 'Neo-Soul', 'Jazz Fusion'],
                            language: ['en'],
                            lyrics: true,
                            game: '6921e33b0eef394c89845fb8',
                            duration: 202,
                        },
                        {
                            id: 'Laat_het_sudderen',
                            title: 'Laat het sudderen',
                            path: 'music/Laat_het_sudderen.mp3',
                            pathPublic: 'Laat_het_sudderen',
                            tags: ['R&B', 'Neo-Soul', 'Jazz Fusion'],
                            language: ['nl'],
                            lyrics: true,
                            game: '6944abab5d2f2d3fde971460',
                            duration: 209,
                        },
                        {
                            id: 'Tunnel_Vision',
                            title: 'Tunnel Vision',
                            path: 'music/Tunnel_Vision.mp3',
                            pathPublic: 'Tunnel_Vision',
                            tags: ['R&B', 'Neo-Soul'],
                            language: ['en'],
                            lyrics: true,
                            game: '69ac5a4510c9adc947dc1981',
                            duration: 203,
                        },
                        {
                            id: 'Sealed_with_a_Kiss',
                            title: 'Sealed with a Kiss',
                            path: 'music/Sealed_with_a_Kiss.mp3',
                            pathPublic: 'Sealed_with_a_Kiss',
                            tags: ['R&B', 'Neo-Soul'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 238,
                        },
                        {
                            id: 'Discover_You',
                            title: 'Discover You',
                            path: 'music/Discover_You.mp3',
                            pathPublic: 'Discover_You',
                            tags: ['Pop'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 178,
                        },
                    ],
                },
            ],
        },
        {
            id: 'poplyn-skye',
            name: 'Poplyn Skye',
            albums: [
                {
                    id: 'petals',
                    name: 'Petals',
                    year: 2025,
                    coverImage: 'images/albums/album_petals.png',
                    coverImagePublic: 'album_petals',
                    songs: [
                        {
                            id: 'Mirror_Game',
                            title: 'Mirror Game',
                            path: 'music/Mirror_Game.mp3',
                            pathPublic: 'Mirror_Game',
                            tags: ['Pop', 'Alternative', 'R&B'],
                            language: ['en'],
                            lyrics: true,
                            game: '68016cb23f0914bff706b7ca',
                            duration: 175,
                        },
                        {
                            id: 'Craving_More',
                            title: 'Craving More',
                            path: 'music/Craving_More.mp3',
                            pathPublic: 'Craving_More',
                            tags: ['Pop', 'Alternative', 'R&B'],
                            language: ['en'],
                            lyrics: true,
                            game: '6701bc6c35797c2928318643',
                            duration: 191,
                        },
                        {
                            id: 'Cry_About_It',
                            title: 'Cry About It',
                            path: 'music/Cry_About_It.mp3',
                            pathPublic: 'Cry_About_It',
                            tags: ['Pop', 'Alternative', 'R&B'],
                            language: ['en'],
                            lyrics: true,
                            game: '67d1c7c8d303f4b1017260a4',
                            duration: 180,
                        },
                        {
                            id: 'String_Me_Along',
                            title: 'String Me Along',
                            path: 'music/String_Me_Along.mp3',
                            pathPublic: 'String_Me_Along',
                            tags: ['Pop', 'Alternative', 'R&B'],
                            language: ['en'],
                            lyrics: true,
                            game: '693bad642f3a8ff742190144',
                            duration: 197,
                        },
                        {
                            id: 'Eat_Your_Heart_Out',
                            title: 'Eat Your Heart Out',
                            path: 'music/Eat_Your_Heart_Out.mp3',
                            pathPublic: 'Eat_Your_Heart_Out',
                            tags: ['Pop', 'Alternative', 'R&B'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 207,
                        },
                        {
                            id: 'Animals',
                            title: 'Animals',
                            path: 'music/Animals.mp3',
                            pathPublic: 'Animals',
                            tags: ['Pop', 'Alternative', 'R&B'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 218,
                        },
                    ],
                },
            ],
        },
        {
            id: 'popa-del-fuego',
            name: 'Popa del Fuego',
            albums: [
                {
                    id: 'memoria-infinita',
                    name: 'Memoria Infinita',
                    year: 2025,
                    coverImage: 'images/albums/album_memoria_infinita.png',
                    coverImagePublic: 'album_memoria_infinita',
                    songs: [
                        {
                            id: 'Clave_Primaria',
                            title: 'Clave Primaria',
                            path: 'music/Clave_Primaria.mp3',
                            pathPublic: 'Clave_Primaria',
                            tags: ['Flamenco'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 170,
                        },
                        {
                            id: 'Falla_de_Consenso',
                            title: 'Falla de Consenso',
                            path: 'music/Falla_de_Consenso.mp3',
                            pathPublic: 'Falla_de_Consenso',
                            tags: ['Flamenco'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 137,
                        },
                        {
                            id: 'Nivel_Final',
                            title: 'Nivel Final',
                            path: 'music/Nivel_Final.mp3',
                            pathPublic: 'Nivel_Final',
                            tags: ['Flamenco'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 156,
                        },
                        {
                            id: 'Vector_de_Luz',
                            title: 'Vector de Luz',
                            path: 'music/Vector_de_Luz.mp3',
                            pathPublic: 'Vector_de_Luz',
                            tags: ['Flamenco'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 174,
                        },
                        {
                            id: 'Latido_de_la_Maquina',
                            title: 'Latido de la Máquina',
                            path: 'music/Latido_de_la_Maquina.mp3',
                            pathPublic: 'Latido_de_la_Maquina',
                            tags: ['Flamenco'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 184,
                        },
                        {
                            id: 'Latencia_Fantasma',
                            title: 'Latencia Fantasma',
                            path: 'music/Latencia_Fantasma.mp3',
                            pathPublic: 'Latencia_Fantasma',
                            tags: ['Flamenco'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 170,
                        },
                        {
                            id: 'Rama_de_Lumbre',
                            title: 'Rama de Lumbre',
                            path: 'music/Rama_de_Lumbre.mp3',
                            pathPublic: 'Rama_de_Lumbre',
                            tags: ['Flamenco'],
                            language: ['en'],
                            lyrics: false,
                            game: 'none',
                            duration: 103,
                        },
                    ],
                },
            ],
        },
        {
            id: 'hippopotamus',
            name: 'Hippopotamus',
            albums: [
                {
                    id: 'river-fork',
                    name: 'River Fork',
                    year: 2025,
                    coverImage: 'images/albums/album_river_fork.png',
                    coverImagePublic: 'album_river_fork',
                    songs: [
                        {
                            id: 'Gallows',
                            title: 'Gallows',
                            path: 'music/Gallows.mp3',
                            pathPublic: 'Gallows',
                            tags: ['Psych Rock', 'Jam Band', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '693bad642f3a8ff742190144',
                            duration: 260,
                        },
                        {
                            id: 'Cooked',
                            title: 'Cooked',
                            path: 'music/Cooked.mp3',
                            pathPublic: 'Cooked',
                            tags: ['Psych Rock', 'Jam Band', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6944abab5d2f2d3fde971460',
                            duration: 248,
                        },
                        {
                            id: 'Burrow',
                            title: 'Burrow',
                            path: 'music/Burrow.mp3',
                            pathPublic: 'Burrow',
                            tags: ['Psych Rock', 'Jam Band', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '69ac5a4510c9adc947dc1981',
                            duration: 245,
                        },
                        {
                            id: 'Silo',
                            title: 'Silo',
                            path: 'music/Silo.mp3',
                            pathPublic: 'Silo',
                            tags: ['Psych Rock', 'Jam Band', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '69c55319c9763aa207ae0fb2',
                            duration: 309,
                        },
                        {
                            id: 'Queue',
                            title: 'Queue',
                            path: 'music/Queue.mp3',
                            pathPublic: 'Queue',
                            tags: ['Psych Rock', 'Jam Band', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a3349523db03ba5ecbf1db2',
                            duration: 208,
                        },
                        {
                            id: 'Alibi',
                            title: 'Alibi',
                            path: 'music/Alibi.mp3',
                            pathPublic: 'Alibi',
                            tags: ['Psych Rock', 'Jam Band', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4445679a8400bf1b9aae8d',
                            duration: 292,
                        },
                        {
                            id: 'Darwin',
                            title: 'Darwin',
                            path: 'music/Darwin.mp3',
                            pathPublic: 'Darwin',
                            tags: ['Psych Rock', 'Jam Band', 'Rock'],
                            language: ['en'],
                            lyrics: true,
                            game: '6a4443ab95150cffae4f482e',
                            duration: 280,
                        },
                    ],
                },
            ],
        },
    ],
};
//# sourceMappingURL=musicLibrary.js.map